import OrganizationEdit from 'src/components/Organization/pages/edit';

export default OrganizationEdit;
